<template>
  <div
    class="frame-selector bg-base-100 w-full border-r border-base-300 p-2 flex flex-col h-full"
  >
    <div class="flex-1 overflow-y-auto min-h-0">
      <div class="space-y-2">
        <div
          v-for="(frame, index) in frames"
          :key="index"
          class="frame-thumbnail relative cursor-pointer border-2 rounded touch-manipulation transition-colors"
          :class="getFrameClass(index)"
          @click="$emit('frame-select', index)"
        >
          <img
            :src="frame.url"
            :alt="`Frame ${index + 1}`"
            class="w-full h-auto rounded"
          />
          <div
            class="absolute bottom-0 right-0 bg-base-content bg-opacity-50 text-base-100 text-xs px-1 rounded-tl"
          >
            {{ index + 1 }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Frame } from "./types";

interface Props {
  frames: Frame[];
  currentFrameIndex: number;
}

interface Emits {
  (e: "frame-select", index: number): void;
}

const props = defineProps<Props>();
defineEmits<Emits>();

const getFrameClass = (index: number) => {
  const baseClass =
    "frame-thumbnail relative cursor-pointer border-2 rounded touch-manipulation transition-colors";

  if (props.currentFrameIndex === index) {
    return `${baseClass} border-primary ring-2 ring-primary ring-opacity-30`;
  }

  return `${baseClass} border-base-300 hover:border-primary`;
};
</script>

<style scoped>
.frame-thumbnail {
  aspect-ratio: 1/2;
}
</style>
